
import { Box } from '@mui/material';
import PropTypes from 'prop-types';
// form
import { FormProvider as Form } from 'react-hook-form';

// ----------------------------------------------------------------------

FormProvider.propTypes = {
    children: PropTypes.node,
    methods: PropTypes.object,
    onSubmit: PropTypes.func,
    styling: PropTypes.object
};

export default function FormProvider({ children, onSubmit, methods, styling }) {
    return (
        <Box sx={{
            ...styling
        }}>
            <Form {...methods} >
                <form onSubmit={onSubmit} style={{
                    ...styling
                }}>{children}</form>
            </Form>
        </Box>
    );
}
